export const oneTapTwotaps = () => {
	var _delay = 500,
		clicks = 0,
		timer = null;

	//Touch Device Logic
	$('#main-nav ul li a')
		.not('#main-nav .children li a')
		.on('click', function (e) {
			e.preventDefault();
			clicks++; //count clicks

			if (clicks === 1) {
				// if (($(this).find('i, div.row').hasClass('activeMenu')) || (isInternational)) {
				if ($(this).find('i, div.row').hasClass('activeMenu')) {
					var _link = $(this).attr('href');
					window.location.href = _link;
				} else {
					timer = setTimeout(function () {
						clicks = 0; //after action performed, reset counter
					}, _delay);
				}
			} else {
				//e.preventDefault();
				clearTimeout(timer); //prevent single-click action
				clicks = 0; //after action performed, reset counter

				return false;
			}
		})
		.on('dblclick', function (e) {
			e.preventDefault(); //cancel system double-click event
		});
};
